const ProjectPesquisaReducer = (state = {}, actions) => {
    switch (actions.type) {
        case 'ProjectsPesquisa':
            return { ...state, projectPesquisa: actions.payload };

        case 'GetProjectPesquisa_Desc':
            return {
                ...state,
                desc: actions.desc,
                asc: actions.asc,
                order: actions.order,
                th: actions.th,
            };

        case 'GetProjectPesquisa_Asc':
            return {
                ...state,
                desc: actions.desc,
                asc: actions.asc,
                order: actions.order,
                th: actions.th,
            };

        case 'qtd_per_page_project_pesquisa':
            return { ...state, qtd_per_page: actions.payload };

        case 'pesquisaProjectPesquisa':
            return { ...state, pesquisa: actions.payload };

        case 'clearPesquisaProjectPesquisa':
            return {
                ...state,
                pesquisa: actions.payload,
                type: actions.payload,
                area: actions.payload,
                manager: actions.payload,
                coordinator: actions.payload,
                status: actions.payload,
                cod_centro_custo: actions.payload,
            };

        case 'pageInitialPesquisa':
            return { ...state, page: actions.payload };

        case 'changePageProjectPesquisa':
            return { ...state, page: actions.payload };

        case 'areaProjectPesquisa':
            return { ...state, area: actions.payload };

        case 'managerProjectPesquisa':
            return { ...state, manager: actions.payload };

        case 'centroCustoProjectPesquisa':
            return { ...state, cod_centro_custo: actions.payload };

        case 'coordenadorProjectPesquisa':
            return { ...state, coordinator: actions.payload };

        case 'statusProjectPesquisa':
            return { ...state, status: actions.payload };

        default:
            return state;
    }
};

export default ProjectPesquisaReducer;
